webpackJsonp([1],{

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BotaoConstituicaoDeEmpresa_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BotaoConstituicaoDeEmpresa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_BotaoConstituicaoDeEmpresa_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ConteudoConstituicaoDeEmpresa_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ConteudoConstituicaoDeEmpresa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ConteudoConstituicaoDeEmpresa_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BotaoAssessoriaContabil_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BotaoAssessoriaContabil_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_BotaoAssessoriaContabil_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ConteudoAssessoriaContabil_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ConteudoAssessoriaContabil_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ConteudoAssessoriaContabil_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_pt_br__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_pt_br__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_pt_br___default.a });

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  components: {
    BotaoConstituicaoDeEmpresa: __WEBPACK_IMPORTED_MODULE_4__components_BotaoConstituicaoDeEmpresa_vue___default.a,
    ConteudoConstituicaoDeEmpresa: __WEBPACK_IMPORTED_MODULE_5__components_ConteudoConstituicaoDeEmpresa_vue___default.a,
    BotaoAssessoriaContabil: __WEBPACK_IMPORTED_MODULE_6__components_BotaoAssessoriaContabil_vue___default.a,
    ConteudoAssessoriaContabil: __WEBPACK_IMPORTED_MODULE_7__components_ConteudoAssessoriaContabil_vue___default.a
  }
});

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validaCnpj; });
var validaCnpj = function validaCnpj(rule, value, callback) {
  var i = 0;
  var cnpj = value.replace(/\D/g, '');
  var pattern = /^(\d{1})1{13}$/;
  var soma = 0;
  var multiplicador = '';
  var digitoUm = '';
  var digitoDois = '';

  if (cnpj.length !== 14) {
    callback(new Error('O CNPJ deve ter 14 digitos'));
  }

  if (pattern.test(cnpj)) {
    callback(new Error('O CNPJ não atende as regras necessárias'));
  }

  for (i = 0; i < 12; i += 1) {
    multiplicador = (i <= 3 ? 5 : 13) - i;

    soma += parseInt(cnpj.charAt(i), 10) * multiplicador;
  }

  soma = soma % 11;

  if (soma === 0 || soma === 1) {
    digitoUm = 0;
  } else {
    digitoUm = 11 - soma;
  }

  if (parseInt(digitoUm, 10) === parseInt(cnpj.charAt(12), 10)) {
    soma = 0;

    for (i = 0; i < 13; i += 1) {
      multiplicador = (i <= 4 ? 6 : 14) - i;
      soma += parseInt(cnpj.charAt(i), 10) * multiplicador;
    }

    soma = soma % 11;

    if (soma === 0 || soma === 1) {
      digitoDois = 0;
    } else {
      digitoDois = 11 - soma;
    }
    if (digitoDois === parseInt(cnpj.charAt(13))) {
      callback();
    }
  }

  callback(new Error('O CNPJ é inválido'));
};

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BotaoAssessoriaContabil',

  props: ['classes'],

  data: function data() {
    return {
      isOpen: false
    };
  },


  methods: {
    showForm: function showForm() {
      this.isOpen = !this.isOpen;
      this.$eventBus.$emit('ASSESSORIA_CONTABIL', this.isOpen);
    }
  }
});

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BotaoConstituicaoDeEmpresa',

  props: ['classes'],

  data: function data() {
    return {
      isOpen: false
    };
  },


  methods: {
    showForm: function showForm() {
      this.isOpen = !this.isOpen;
      this.$eventBus.$emit('CONSTITUICAO_DE_EMPRESA', this.isOpen);
    }
  }
});

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  methods: {
    removerSocio: function removerSocio(item) {
      this.form.socios.splice(this.form.socios.indexOf(item), 1);
    },
    adicionarSocio: function adicionarSocio() {
      this.form.socios.push({
        key: Date.now(),
        nome: ''
      });
    }
  }
});

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
  },

  methods: {
    removerAtividade: function removerAtividade(item) {
      var index = this.form.atividades.indexOf(item);

      if (item !== -1) {
        this.form.atividades.splice(index, 1);
      }
    },
    adicionarAtividade: function adicionarAtividade() {
      this.form.atividades.push({
        key: Date.now(),
        nome: '',
        descricao: ''
      });
    }
  }
});

/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators_cpf_js__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default.a
  },

  data: function data() {
    return {
      estadosCiveis: ['Solteiro', 'Casado', 'Divorciado', 'Viuvo'],
      rules: {
        capitalSocial: [{ required: true, message: 'O valor do capital social é obrigatório', trigger: 'blur' }]
      }
    };
  },


  methods: {
    validateCpf: function validateCpf(rule, value, callback, source) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__validators_cpf_js__["a" /* validaCpf */])(rule, value, callback, source);
    },

    validateUniqueAdministrator: function validateUniqueAdministrator(rule, value, callback) {
      var hasntAdministrator = this.form.socios.every(function (element) {
        return element.socioAdministrador === false;
      });

      if (hasntAdministrator) {
        callback(new Error('Um dos sócios deve ser o administrador'));
      } else {
        callback();
      }
    },
    alertProLabore: function alertProLabore(value) {
      if (value === true) {
        this.$message({ type: 'info', message: 'Importante: Para ficar ISENTO do Recolhimento do INSS do sócio, alterar para a opção NÃO.' });
      }
    },
    updateAdministrator: function updateAdministrator(el) {
      this.form.socios.filter(function (element) {
        return element !== el;
      }).map(function (socio) {
        socio.socioAdministrador = false;
      });
    },
    updateCommunity: function updateCommunity(estado, socio) {
      if (estado !== 'Casado') {
        this.form.socios[socio].comunhaoDeBens = false;
      }
    },
    removePartner: function removePartner(item) {
      this.form.socios.splice(this.form.socios.indexOf(item), 1);
    },
    addPartner: function addPartner() {
      this.form.socios.push({
        key: Date.now(),
        nome: '',
        dataNascimento: '',
        estadoCivil: 'Solteiro',
        comunhaoDeBens: false,
        profissao: '',
        nacionalidade: '',
        naturalidade: '',
        rg: '',
        cpf: '',
        tituloEleitor: '',
        participacaoSocietaria: 0,
        retiraProLabore: false,
        socioAdministrador: false
      });
    }
  }
});

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  data: function data() {
    return {
      rules: {
        formaAtendimento: [{ required: true, message: 'É obrigatório marcar uma das opções', trigger: 'change' }],
        tipoEmpresa: [{ required: true, message: 'É obrigatório marcar uma das opções', trigger: 'change' }]
      }
    };
  }
});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  data: function data() {
    return {
      isLoading: false,
      disableField: false,
      fileAlreadyUploaded: false,
      rules: {
        arquivos: [{ type: 'array', required: true, message: 'Você precisa anexar no mínimo 4 anexos (Documentos mínimos)', min: 4 }]
      }
    };
  },


  methods: {
    onRemove: function onRemove(file, arquivos) {
      var _this = this;

      if (!this.fileAlreadyUploaded) {
        this.$http.headers.common['Access-Control-Allow-Origin'] = '*';
        this.$http.post('https://cdn.icnex.com/formularios12/?arquivos&remover', file).then(function (response) {
          if (response.ok && response.body === true) {
            _this.form.arquivos.splice(_this.form.arquivos.indexOf(file), 1);
          }
        });
      }

      this.fileAlreadyUploaded = false;
    },
    onSuccess: function onSuccess(response, file, files) {
      this.disableField = false;
      this.form.arquivos.push(file);
    },
    onError: function onError(err, file, fileList) {
      console.log(err);
    },
    beforeUpload: function beforeUpload(file) {
      this.disableField = true;

      var dontExistsYet = this.form.arquivos.every(function (arquivo) {
        return arquivo.name !== file.name && arquivo.lastModified !== file.lastModified;
      });

      if (!dontExistsYet) {
        this.fileAlreadyUploaded = true;
        this.$message({ message: 'Você já adicionou esse arquivo' });
      }

      var extensions = ['image/jpeg', 'image/png', 'application/pdf', 'text/plain', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
      var validExtension = extensions.includes(file.type);

      var smallerThan5Mb = file.size / 1024 / 1024 < 5;

      if (!validExtension) {
        this.$message({ type: 'error', message: 'A extensão do arquivo não é válida' });
      }

      if (!smallerThan5Mb) {
        this.$message({ type: 'error', message: 'O arquivo não pode ser maior que 5mb' });
      }

      return dontExistsYet && validExtension && smallerThan5Mb;
    }
  }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_awesome_mask__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default.a
  },

  data: function data() {
    return {
      isLoading: false,
      isDisabled: false,
      rules: {
        cep: [{ required: true, message: 'O CEP é obrigatório', trigger: 'blur' }, { type: 'string', pattern: /[0-9]{5}-[0-9]{3}/, message: 'Você deve digitar um CEP no formato correto: Ex. 99999-999', trigger: 'blur' }],
        logradouro: [{ required: true, message: 'O endereço é obrigatório', trigger: 'blur' }],
        numero: [{ required: true, message: 'O número é obrigatório', trigger: 'blur' }],
        bairro: [{ required: true, message: 'O bairro é obrigatório', trigger: 'blur' }],
        cidade: [{ required: true, message: 'A cidade é obrigatória', trigger: 'blur' }],
        estado: [{ required: true, message: 'O estado é obrigatório', trigger: 'blur' }]
      }
    };
  },


  watch: {
    'form.cep': function formCep(value, oldValue) {
      if (value.length === 9) {
        this.searchAddress();
      }
    }
  },

  methods: {
    searchAddress: function searchAddress() {
      var _this = this;

      var cep = this.form.cep.replace(/\D+/g, '');

      if (cep.length === 8) {
        this.isLoading = true;

        this.$http.get('https://api.postmon.com.br/v1/cep/' + cep).then(function (response) {
          _this.isLoading = false;

          if (response.ok) {
            _this.isDisabled = true;

            _this.form.numero = '';
            _this.form.logradouro = response.data.logradouro;
            _this.form.bairro = response.data.bairro;
            _this.form.cidade = response.data.cidade;
            _this.form.estado = response.data.estado;

            _this.$refs.numero.$refs.input.focus();
          }
        }).catch(function (response) {
          _this.isLoading = false;

          _this.$message({ showClose: true, type: 'error', message: response.statusText });

          _this.isDisabled = false;

          _this.$refs.form.resetFields();
        });
      }
    }
  }
});

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  data: function data() {
    return {
      rules: {
        nomeFantasia: [{ required: true, message: 'O nome fantasia da empresa é obrigatório', trigger: 'blur' }]
      }
    };
  },


  methods: {
    removeName: function removeName(item) {
      this.form.razoesSociais.splice(this.form.razoesSociais.indexOf(item), 1);
    },
    addName: function addName() {
      this.form.razoesSociais.push({
        key: Date.now(),
        nome: ''
      });
    }
  }
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators_cpf_js__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['form'],

  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_0_awesome_mask___default.a
  },

  data: function data() {
    return {
      rules: {
        nome: [{ required: true, message: 'O nome é obrigatório', trigger: 'blur' }],
        email: [{ required: true, message: 'O email é obrigatório', trigger: 'blur' }, { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }],
        telefone: [{ type: 'string', pattern: /\((10)|([1-9][1-9])\) [0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto: Ex. (99) 9999-9999', trigger: 'blur' }],
        celular: [{ required: true, message: 'Um número de celular é obrigatório', trigger: 'blur' }, { type: 'string', pattern: /\((10)|([1-9][1-9])\) [9][0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um celular no formato correto: Ex. (99) 99999-9999', trigger: 'blur' }],
        cpf: [{ required: true, message: 'O CPF é obrigatório', trigger: 'blur' }, { validator: __WEBPACK_IMPORTED_MODULE_1__validators_cpf_js__["a" /* validaCpf */], trigger: 'blur' }]
      }
    };
  }
});

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_awesome_mask__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_awesome_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators_cnpj_js__ = __webpack_require__(110);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssessoriaContabil',

  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha___default.a
  },

  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_2_awesome_mask___default.a
  },

  data: function data() {
    return {
      sitekey: '6Ldv0esUAAAAAEfgh5OYk1RuQ3Is34jLR-HNL_G3',
      isLoading: false,
      isReseting: false,
      form: {
        _recaptcha: {
          _response: '',
          _valid: false
        },
        nome: '',
        socio: true,
        outro: '',
        email: '',
        telefone: '',
        celular: '',
        nomeEmpresa: '',
        cnpjEmpresa: '',
        ramoAtuacao: '',
        faturamentoMedio: '',
        quantidadeFuncionarios: 0,
        quantidadeNotasEmitidas: 0,
        adquireMercadoriasOutrosEstados: '',
        atuaExportacaoImportacao: '',
        possuiSoftwareGestao: '',
        possuiProfissionalAdministrativo: '',
        rotatividadeMensalFuncionarios: 0,
        _valid: false
      },
      newForm: {
        nome: 'Lorem Ipsum',
        socio: true,
        outro: '',
        email: 'lorem@ipsum.com',
        telefone: '(41) 3434-5592',
        celular: '(41) 98707-8479',
        nomeEmpresa: 'Lorem Ipsum Inc',
        cnpjEmpresa: '81.253.460/0001-23',
        ramoAtuacao: 'Mauris lacus ipsum, euismod ac aliquam in, pulvinar ac dolor. Maecenas fringilla, tortor eu tincidunt tempus, sapien lectus efficitur justo, eu congue ligula erat sit amet urna. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nec luctus ipsum. Proin in pretium nibh. Proin suscipit tempor risus, quis hendrerit enim viverra pellentesque. Quisque at sapien quis purus porttitor dignissim vitae ut ipsum.',
        faturamentoMedio: '99.999,99',
        quantidadeFuncionarios: 99,
        quantidadeNotasEmitidas: 999,
        adquireMercadoriasOutrosEstados: 'Sim',
        atuaExportacaoImportacao: 'Não sei',
        possuiSoftwareGestao: 'Não',
        possuiProfissionalAdministrativo: 'Sim',
        rotatividadeMensalFuncionarios: 9
      },
      rules: {
        nome: [{ required: true, message: 'O nome é obrigatório', trigger: 'blur' }],
        email: [{ required: true, message: 'O email é obrigatório', trigger: 'blur' }, { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }],
        telefone: [{ type: 'string', pattern: /\((10)|([1-9][1-9])\) [0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto: Ex. (99) 9999-9999', trigger: 'blur' }],
        celular: [{ required: true, message: 'Um número de celular é obrigatório', trigger: 'blur' }, { type: 'string', pattern: /\((10)|([1-9][1-9])\) [9][0-9]{4}-[0-9]{4}/, message: 'Você deve digitar um celular no formato correto: Ex. (99) 99999-9999', trigger: 'blur' }],
        nomeEmpresa: [{ required: true, message: 'O nome da empresa é obrigatório', trigger: 'blur' }],
        cnpjEmpresa: [{ required: true, message: 'O CNPJ da empresa é obrigatório', trigger: 'blur' }, { validator: __WEBPACK_IMPORTED_MODULE_3__validators_cnpj_js__["a" /* validaCnpj */], trigger: 'blur' }],
        ramoAtuacao: [{ required: true, message: 'O ramo de atuação é obrigatório', trigger: 'blur' }],
        faturamentoMedio: [{ required: true, message: 'É obrigatório informar o faturamento médio da empresa', trigger: 'blur' }],
        quantidadeFuncionarios: [{ type: 'integer', required: true, message: 'É obrigatório informar a quantidade de funcionários', trigger: 'blur' }],
        quantidadeNotasEmitidas: [{ type: 'integer', required: true, message: 'É obrigatório informar a quantidade de notas emitidas no mês', trigger: 'blur' }],
        adquireMercadoriasOutrosEstados: [{ required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }],
        atuaExportacaoImportacao: [{ required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }],
        possuiSoftwareGestao: [{ required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }],
        possuiProfissionalAdministrativo: [{ required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'change' }],
        rotatividadeMensalFuncionarios: [{ type: 'integer', required: true, message: 'É obrigatório selecionar uma das opções', trigger: 'blur' }]
      },
      showForm: false
    };
  },


  computed: {
    totalSteps: function totalSteps() {
      return this.steps.length;
    },
    isValid: function isValid() {
      return this.form._valid && this.form._recaptcha._valid;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$eventBus.$on('ASSESSORIA_CONTABIL', function (payload) {
      _this.showForm = payload;

      var uri = window.location.search.substring(1);
      var params = new URLSearchParams(uri);

      if (params.get('test') !== null) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.$data.form, _this.newForm);
      }
    });
  },


  watch: {
    form: {
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          if (!_this2.isReseting) {
            _this2.verifyValidation();
          } else {
            _this2.isReseting = false;
          }
        });
      },

      deep: true
    }
  },

  methods: {
    cleanOutro: function cleanOutro() {
      this.form.outro = '';
    },
    sendForm: function sendForm() {
      var _this3 = this;

      this.isLoading = true;

      if (this.isValid) {
        this.$http.post('https://cdn.icnex.com/formularios12/?assessoria-contabil', this.form, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Request-Methods': 'GET,POST'
          }
        }).then(function (response) {
          _this3.$message.success('Enviado com sucesso! Aguarde nosso contato');

          _this3.$nextTick(function () {
            _this3.backToBeginSetup();
          });
        }).catch(function (response) {
          _this3.$message.error('Houve um erro! Por favor tente novamente mais tarde ou entre em contato.');

          _this3.$nextTick(function () {
            _this3.backToBeginSetup();
          });
        });
      }
    },
    verifyRecaptcha: function verifyRecaptcha(recaptcha) {
      this.form._recaptcha = {
        _response: recaptcha,
        _valid: true
      };
    },
    recaptchaExpired: function recaptchaExpired() {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' });

      this.form._recaptcha = {
        _response: '',
        _valid: false
      };
    },
    verifyValidation: function verifyValidation() {
      var _this4 = this;

      this.$refs.form.validate(function (valid) {
        _this4.form._valid = valid;

        return valid;
      });
    },
    backToBeginSetup: function backToBeginSetup() {
      this.isReseting = true;
      this.$refs._recaptcha.reset();
      this.$refs.form.resetFields();
      this.isLoading = false;
      this.showForm = false;
    }
  }
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConstituicaoDeEmpresa_Solicitante__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConstituicaoDeEmpresa_Solicitante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConstituicaoDeEmpresa_Solicitante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConstituicaoDeEmpresa_PessoaJuridica__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConstituicaoDeEmpresa_PessoaJuridica___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConstituicaoDeEmpresa_PessoaJuridica__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConstituicaoDeEmpresa_EnderecoEmpresa__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConstituicaoDeEmpresa_EnderecoEmpresa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConstituicaoDeEmpresa_EnderecoEmpresa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConstituicaoDeEmpresa_AtividadesSerExercida__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConstituicaoDeEmpresa_AtividadesSerExercida___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ConstituicaoDeEmpresa_AtividadesSerExercida__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConstituicaoDeEmpresa_ContratoSocial__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConstituicaoDeEmpresa_ContratoSocial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ConstituicaoDeEmpresa_ContratoSocial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConstituicaoDeEmpresa_AdministracaoAssinatura__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConstituicaoDeEmpresa_AdministracaoAssinatura___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ConstituicaoDeEmpresa_AdministracaoAssinatura__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConstituicaoDeEmpresa_Diversos__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConstituicaoDeEmpresa_Diversos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ConstituicaoDeEmpresa_Diversos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ConstituicaoDeEmpresa_DocumentosNecessarios__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ConstituicaoDeEmpresa_DocumentosNecessarios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ConstituicaoDeEmpresa_DocumentosNecessarios__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConteudoConstituicaoDeEmpresa',

  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha___default.a,
    Solicitante: __WEBPACK_IMPORTED_MODULE_3__ConstituicaoDeEmpresa_Solicitante___default.a,
    PessoaJuridica: __WEBPACK_IMPORTED_MODULE_4__ConstituicaoDeEmpresa_PessoaJuridica___default.a,
    EnderecoEmpresa: __WEBPACK_IMPORTED_MODULE_5__ConstituicaoDeEmpresa_EnderecoEmpresa___default.a,
    AtividadesSerExercida: __WEBPACK_IMPORTED_MODULE_6__ConstituicaoDeEmpresa_AtividadesSerExercida___default.a,
    ContratoSocial: __WEBPACK_IMPORTED_MODULE_7__ConstituicaoDeEmpresa_ContratoSocial___default.a,
    AdministracaoAssinatura: __WEBPACK_IMPORTED_MODULE_8__ConstituicaoDeEmpresa_AdministracaoAssinatura___default.a,
    Diversos: __WEBPACK_IMPORTED_MODULE_9__ConstituicaoDeEmpresa_Diversos___default.a,
    DocumentosNecessarios: __WEBPACK_IMPORTED_MODULE_10__ConstituicaoDeEmpresa_DocumentosNecessarios___default.a
  },

  data: function data() {
    return {
      sitekey: '6Ldv0esUAAAAAEfgh5OYk1RuQ3Is34jLR-HNL_G3',
      step: 0,
      steps: [{ class: 'finish' }, { class: 'wait' }, { class: 'wait' }, { class: 'wait' }, { class: 'wait' }, { class: 'wait' }, { class: 'wait' }, { class: 'wait' }],
      isLoading: false,
      isReseting: false,
      form: {
        _recaptcha: {
          _response: '',
          _valid: false
        },
        solicitante: {
          nome: '',
          email: '',
          telefone: '',
          celular: '',
          cpf: '',
          _valid: false
        },
        pessoaJuridica: {
          nomeFantasia: '',
          razoesSociais: [{ key: 1, nome: '' }, { key: 2, nome: '' }, { key: 3, nome: '' }],
          _valid: false
        },
        enderecoEmpresa: {
          cep: '',
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          _valid: false
        },
        atividadesSerExercida: {
          atividades: [{ nome: '', descricao: '' }],
          _valid: false
        },
        contratoSocial: {
          capitalSocial: '',
          socios: [{
            key: 1,
            nome: '',
            dataNascimento: '',
            estadoCivil: 'Solteiro',
            comunhaoDeBens: false,
            profissao: '',
            nacionalidade: '',
            naturalidade: '',
            rg: '',
            cpf: '',
            tituloEleitor: '',
            participacaoSocietaria: 0,
            retiraProLabore: false,
            socioAdministrador: true
          }],
          _valid: false
        },
        diversos: {
          formaAtendimento: '',
          tipoEmpresa: '',
          outrasInformacoes: '',
          _valid: false
        },
        administracaoAssinatura: {
          tipo: 'Em conjunto',
          socios: [{ key: 1, nome: '' }],
          _valid: false
        },
        documentosNecessarios: {
          arquivos: [],
          _valid: false
        }
      },
      newForm: {
        _recaptcha: {
          _response: '',
          _valid: false
        },
        solicitante: {
          nome: 'Lorem Ipsum',
          email: 'lorem@ipsum.com',
          telefone: '(41) 3434-5592',
          celular: '(41) 98707-8479',
          cpf: '794.200.160-13',
          _valid: true
        },
        pessoaJuridica: {
          nomeFantasia: 'Nulla porta metus vel libero',
          razoesSociais: [{ key: 1, nome: 'Mauris nec lorem sed risus' }, { key: 2, nome: 'Suspendisse congue, ex sit amet' }, { key: 3, nome: 'In congue purus eget feugiat' }],
          _valid: true
        },
        enderecoEmpresa: {
          cep: '99999-999',
          logradouro: 'Donec non sodales magna',
          numero: '999',
          complemento: 'Tortor',
          bairro: 'Ornare vel',
          cidade: 'Sed et malesuada nisl',
          estado: 'Integer',
          _valid: true
        },
        atividadesSerExercida: {
          atividades: [{ nome: 'Phasellus turpis ', descricao: 'Mauris laoreet aliquam consequat. Aliquam' }],
          _valid: true
        },
        contratoSocial: {
          capitalSocial: '9.999,999',
          socios: [{
            key: 1,
            nome: 'Lorem Ipsum',
            dataNascimento: new Date(),
            estadoCivil: 'Solteiro',
            comunhaoDeBens: false,
            profissao: 'Duis',
            nacionalidade: 'Praesent',
            naturalidade: 'Curabitur',
            rg: '9.999.999-9',
            cpf: '794.200.160-13',
            tituloEleitor: '',
            participacaoSocietaria: 0,
            retiraProLabore: false,
            socioAdministrador: true
          }],
          _valid: true
        },
        diversos: {
          formaAtendimento: 'Atendimento no Local',
          tipoEmpresa: 'Sociedade (Limitada)',
          outrasInformacoes: '',
          _valid: true
        },
        administracaoAssinatura: {
          tipo: 'Em conjunto',
          socios: [{ key: 1, nome: 'Lorem Ipsum' }],
          _valid: true
        },
        documentosNecessarios: {
          arquivos: [],
          _valid: false
        }
      },
      showForm: false
    };
  },


  computed: {
    totalSteps: function totalSteps() {
      return this.steps.length;
    },
    isValid: function isValid() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.form).every(function (component) {
        return component._valid;
      });
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$eventBus.$on('CONSTITUICAO_DE_EMPRESA', function (payload) {
      _this.showForm = payload;

      var uri = window.location.search.substring(1);
      var params = new URLSearchParams(uri);

      if (params.get('test') !== null) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.$data.form, _this.newForm);
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.$data.steps, [{ class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' }, { class: 'success' }]);
      }
    });
  },


  watch: {
    form: {
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          if (!_this2.isReseting) {
            _this2.verifyValidation();
          } else {
            _this2.isReseting = false;
          }
        });
      },

      deep: true
    }
  },

  methods: {
    changeStep: function changeStep(step) {
      this.step = step;
    },
    updateStepClass: function updateStepClass(step, name) {
      this.steps[step].class = name;
    },
    getStepCursor: function getStepCursor(step) {
      var style = this.step !== step ? 'pointer' : 'default';

      return 'cursor: ' + style;
    },
    sendForm: function sendForm() {
      var _this3 = this;

      this.isLoading = true;
      var hasFailure = this.steps.every(function (el, index) {
        return _this3.verifyValidation(index) === false;
      });

      if (!hasFailure) {
        this.$http.post('https://cdn.icnex.com/formularios12/?constituicao-de-empresa', this.form).then(function (response) {
          _this3.$message.success('Enviado com sucesso! Aguarde nosso contato');

          _this3.$nextTick(function () {
            _this3.backToBeginSetup();
          });
        }).catch(function (response) {
          _this3.$message.error('Houve um erro! Por favor tente novamente mais tarde ou entre em contato.');

          _this3.$nextTick(function () {
            _this3.backToBeginSetup();
          });
        });
      }
    },
    verifyRecaptcha: function verifyRecaptcha(recaptcha) {
      this.form._recaptcha = {
        _response: recaptcha,
        _valid: true
      };
    },
    recaptchaExpired: function recaptchaExpired() {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' });

      this.form._recaptcha = {
        _response: '',
        _valid: false
      };
    },
    verifyValidation: function verifyValidation(step) {
      var _this4 = this;

      var activeStep = step || this.step;

      this.$refs['step-' + activeStep].$refs['form'].validate(function (valid) {
        _this4.$refs['step-' + activeStep].form._valid = valid;

        if (valid) {
          _this4.updateStepClass(activeStep, 'success');
        } else {
          _this4.updateStepClass(activeStep, 'error');
        }

        return valid;
      });
    },
    backToBeginSetup: function backToBeginSetup() {
      var _this5 = this;

      this.isReseting = true;
      this.$refs._recaptcha.reset();
      this.steps.forEach(function (step, index) {
        _this5.$refs['step-' + index].$refs['form'].resetFields();
        _this5.$nextTick(function () {
          if (index === 0) {
            step.class = 'finish';
          } else {
            step.class = 'wait';
          }
        });
      });
      this.isLoading = false;
      this.showForm = false;
      this.step = 0;
    },
    goToStep: function goToStep(step) {
      if (step === this.step) {
        return;
      }

      this.verifyValidation();

      this.updateStepClass(step, 'finish');

      this.changeStep(step);
    }
  }
});

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(201),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('p', [_vm._v("Descreva todas as atividades a serem exercidas pela Empresa. Havendo mais de uma atividade, ordene-as de acordo com a ordem de atuação, iniciando com a atividade principal.")]), _vm._v(" "), _c('draggable', {
    model: {
      value: (_vm.form.atividades),
      callback: function($$v) {
        _vm.$set(_vm.form, "atividades", $$v)
      },
      expression: "form.atividades"
    }
  }, [_c('transition-group', _vm._l((_vm.form.atividades), function(atividade, index) {
    return _c('div', {
      key: atividade + '_' + index
    }, [_c('h3', [(_vm.form.atividades.length > 1) ? _c('i', {
      staticClass: "el-icon-d-caret",
      staticStyle: {
        "cursor": "pointer"
      }
    }) : _vm._e(), _vm._v(" \n          Atividade " + _vm._s(index + 1) + "\n          "), (_vm.form.atividades.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removerAtividade(atividade)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Nome",
        "prop": 'atividades.' + index + '.nome',
        "rules": {
          required: true,
          message: 'O nome da atividade é obrigatória',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      model: {
        value: (atividade.nome),
        callback: function($$v) {
          _vm.$set(atividade, "nome", $$v)
        },
        expression: "atividade.nome"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Descrição",
        "prop": 'atividades.' + index + '.descricao',
        "rules": {
          required: true,
          message: 'A descrição da atividade é obrigatória',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      model: {
        value: (atividade.descricao),
        callback: function($$v) {
          _vm.$set(atividade, "descricao", $$v)
        },
        expression: "atividade.descricao"
      }
    })], 1)], 1)
  }), 0)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.adicionarAtividade
    }
  }, [_vm._v("Adicionar Atividade")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "formaAtendimento"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "color": "#ff4949"
    }
  }, [_vm._v("*")]), _vm._v(" Como será a forma de atendimento?")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.formaAtendimento),
      callback: function($$v) {
        _vm.$set(_vm.form, "formaAtendimento", $$v)
      },
      expression: "form.formaAtendimento"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Atendimento no Local"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Simples Escritório - Somente ponto de referência"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Online"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Outros"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tipoEmpresa"
    }
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "color": "#ff4949"
    }
  }, [_vm._v("*")]), _vm._v(" Tipo de Empresa")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.tipoEmpresa),
      callback: function($$v) {
        _vm.$set(_vm.form, "tipoEmpresa", $$v)
      },
      expression: "form.tipoEmpresa"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Sociedade (Limitada)"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Individual Limitada (Eireli)"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Associações (Condomínios, Igrejas, etc...)"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "outrasInformacoes"
    }
  }, [_c('h3', [_vm._v("Outras Informações")]), _vm._v(" "), _c('em', [_vm._v("Inserir informações que julgar necessário")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.outrasInformacoes),
      callback: function($$v) {
        _vm.$set(_vm.form, "outrasInformacoes", $$v)
      },
      expression: "form.outrasInformacoes"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nome Completo",
      "prop": "nome"
    }
  }, [_c('em', [_vm._v("Nome do sócio administrador, empresário ou representante legal")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Nome Completo"
    },
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.$set(_vm.form, "nome", $$v)
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telefone Fixo",
      "prop": "telefone"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telefone),
      expression: "form.telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(99) 9999-9999'),
      expression: "'(99) 9999-9999'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "(99) 9999-9999"
    },
    domProps: {
      "value": (_vm.form.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "telefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Celular",
      "prop": "celular"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.celular),
      expression: "form.celular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(99) 99999-9999'),
      expression: "'(99) 99999-9999'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "(99) 99999-9999"
    },
    domProps: {
      "value": (_vm.form.celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "celular", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CPF",
      "prop": "cpf"
    }
  }, [_c('em', [_vm._v("CPF do sócio administrador da empresa ou solicitante")]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cpf),
      expression: "form.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "999.999.999-99"
    },
    domProps: {
      "value": (_vm.form.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cpf", $event.target.value)
      }
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    class: _vm.classes,
    on: {
      "click": _vm.showForm
    }
  }, [_vm._t("default", [_vm._v("Solicite orçamento para abertura de sua empresa")])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "nomeFantasia"
    }
  }, [_c('h3', [_vm._v("Assinatura")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.tipo),
      callback: function($$v) {
        _vm.$set(_vm.form, "tipo", $$v)
      },
      expression: "form.tipo"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Em conjunto"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Isolada"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.form.tipo === 'Em conjunto') ? _c('em', [_c('strong', [_vm._v("Importante:")]), _vm._v(" A assinatura perante Instituições Públicas e Bancárias só terá validade se tiver a assinatura de ambos os sócios")]) : _vm._e()], 1), _vm._v(" "), _c('h3', [_vm._v("Será exercida pelos sócios:")]), _vm._v(" "), _vm._l((_vm.form.socios), function(socio, index) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": "Nome Completo",
        "prop": 'socios.' + index + '.nome',
        "rules": {
          required: true,
          message: 'O nome é obrigatório',
          trigger: 'blur'
        }
      }
    }, [(_vm.form.socios.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.removerSocio(socio)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e(), _vm._v(" "), _c('el-input', {
      model: {
        value: (socio.nome),
        callback: function($$v) {
          _vm.$set(socio, "nome", $$v)
        },
        expression: "socio.nome"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.adicionarSocio
    }
  }, [_vm._v("Adicionar Sócio")])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nome Fantasia",
      "prop": "nomeFantasia"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nomeFantasia),
      callback: function($$v) {
        _vm.$set(_vm.form, "nomeFantasia", $$v)
      },
      expression: "form.nomeFantasia"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form.razoesSociais), function(razaoSocial, index) {
    return _c('el-form-item', {
      key: razaoSocial.key,
      attrs: {
        "label": 'Razão Social - ' + (index + 1) + 'ª Opção',
        "prop": 'razoesSociais.' + index + '.nome',
        "rules": {
          required: true,
          message: 'A razão social da empresa é obrigatório',
          trigger: 'blur'
        }
      }
    }, [(_vm.form.razoesSociais.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.removeName(razaoSocial)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e(), _vm._v(" "), _c('el-input', {
      model: {
        value: (razaoSocial.nome),
        callback: function($$v) {
          _vm.$set(razaoSocial, "nome", $$v)
        },
        expression: "razaoSocial.nome"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addName
    }
  }, [_vm._v("Adicionar Razão Social")])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Capital Social",
      "prop": "capitalSocial",
      "rules": {
        required: true,
        message: 'O capital social é obrigatório',
        trigger: 'blur'
      }
    }
  }, [_c('em', [_vm._v("Valor investido para abertura e funcionamento da empresa")]), _vm._v(" "), _c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('div', {
    staticClass: "el-input-group__prepend"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.capitalSocial),
      expression: "form.capitalSocial"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.capitalSocial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "capitalSocial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v("Participação Societária")]), _vm._v(" "), _vm._l((_vm.form.socios), function(socio, index) {
    return _c('div', [_c('h4', [_vm._v("Sócio " + _vm._s(index + 1) + " "), (_vm.form.socios.length > 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removePartner(socio)
        }
      }
    }, [_vm._v("Deletar")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nome",
        "prop": 'socios.' + index + '.nome',
        "rules": {
          required: true,
          message: 'O nome do sócio é obrigatório',
          trigger: 'blur'
        }
      }
    }, [_c('el-input', {
      model: {
        value: (socio.nome),
        callback: function($$v) {
          _vm.$set(socio, "nome", $$v)
        },
        expression: "socio.nome"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 7
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'socios.' + index + '.socioAdministrador',
        "rules": {
          validator: _vm.validateUniqueAdministrator,
          trigger: 'change'
        }
      }
    }, [_c('label', {
      staticClass: "el-form-item__label",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      },
      attrs: {
        "for": ("socios." + index + ".comunhaoDeBens")
      }
    }, [_vm._v("Sócio Administrador?")]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "active-text": "Sim",
        "inactive-text": "Não",
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      },
      on: {
        "change": function($event) {
          return _vm.updateAdministrator(socio)
        }
      },
      model: {
        value: (socio.socioAdministrador),
        callback: function($$v) {
          _vm.$set(socio, "socioAdministrador", $$v)
        },
        expression: "socio.socioAdministrador"
      }
    }, [_vm._v("Sócio Administrador?")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'socios.' + index + '.participacaoSocietaria'
      }
    }, [_c('label', {
      staticClass: "el-form-item__label",
      staticStyle: {
        "float": "none",
        "text-align": "left"
      },
      attrs: {
        "for": ("socios." + index + ".participacaoSocietaria")
      }
    }, [_vm._v("Participação Societária em %?")]), _vm._v(" "), _c('el-slider', {
      attrs: {
        "show-input": ""
      },
      model: {
        value: (socio.participacaoSocietaria),
        callback: function($$v) {
          _vm.$set(socio, "participacaoSocietaria", $$v)
        },
        expression: "socio.participacaoSocietaria"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'socios.' + index + '.retiraProLabore'
      }
    }, [_c('label', {
      staticClass: "el-form-item__label",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      },
      attrs: {
        "for": ("socios." + index + ".retiraProLabore")
      }
    }, [_vm._v("Retira Pró-Labore?")]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "active-text": "Sim",
        "inactive-text": "Não",
        "active-color": "#13ce66",
        "inactive-color": "#ff4949"
      },
      on: {
        "change": _vm.alertProLabore
      },
      model: {
        value: (socio.retiraProLabore),
        callback: function($$v) {
          _vm.$set(socio, "retiraProLabore", $$v)
        },
        expression: "socio.retiraProLabore"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Data de Nascimento",
        "prop": 'socios.' + index + '.dataNascimento',
        "rules": {
          type: 'date',
          required: true,
          message: 'A data de nascimento é obrigatória',
          trigger: 'blur'
        }
      }
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "date",
        "format": "dd/MM/yyyy",
        "placeholder": "DD/MM/AAAA"
      },
      model: {
        value: (socio.dataNascimento),
        callback: function($$v) {
          _vm.$set(socio, "dataNascimento", $$v)
        },
        expression: "socio.dataNascimento"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 7
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Estado Cívil",
        "prop": 'socios.' + index + '.estadoCivil'
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      on: {
        "change": function($event) {
          return _vm.updateCommunity(socio.estadoCivil, index)
        }
      },
      model: {
        value: (socio.estadoCivil),
        callback: function($$v) {
          _vm.$set(socio, "estadoCivil", $$v)
        },
        expression: "socio.estadoCivil"
      }
    }, _vm._l((_vm.estadosCiveis), function(estado) {
      return _c('el-option', {
        key: estado,
        attrs: {
          "label": estado,
          "value": estado
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 7
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'socios.' + index + '.comunhaoDeBens'
      }
    }, [_c('label', {
      staticClass: "el-form-item__label",
      staticStyle: {
        "width": "100%",
        "text-align": "left"
      },
      attrs: {
        "for": ("socios." + index + ".comunhaoDeBens")
      }
    }, [_vm._v("Comunhão de Bens?")]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "active-text": "Sim",
        "inactive-text": "Não",
        "active-color": "#13ce66",
        "inactive-color": "#ff4949",
        "disabled": socio.estadoCivil !== 'Casado'
      },
      model: {
        value: (socio.comunhaoDeBens),
        callback: function($$v) {
          _vm.$set(socio, "comunhaoDeBens", $$v)
        },
        expression: "socio.comunhaoDeBens"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Profissão",
        "prop": 'socios.' + index + '.profissao'
      }
    }, [_c('el-input', {
      model: {
        value: (socio.profissao),
        callback: function($$v) {
          _vm.$set(socio, "profissao", $$v)
        },
        expression: "socio.profissao"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 7
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Nacionalidade",
        "prop": 'socios.' + index + '.nacionalidade'
      }
    }, [_c('el-input', {
      model: {
        value: (socio.nacionalidade),
        callback: function($$v) {
          _vm.$set(socio, "nacionalidade", $$v)
        },
        expression: "socio.nacionalidade"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 7
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Naturalidade",
        "prop": 'socios.' + index + '.naturalidade'
      }
    }, [_c('el-input', {
      model: {
        value: (socio.naturalidade),
        callback: function($$v) {
          _vm.$set(socio, "naturalidade", $$v)
        },
        expression: "socio.naturalidade"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "RG",
        "prop": 'socios.' + index + '.rg'
      }
    }, [_c('el-input', {
      model: {
        value: (socio.rg),
        callback: function($$v) {
          _vm.$set(socio, "rg", $$v)
        },
        expression: "socio.rg"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 7
      }
    }, [_c('el-form-item', {
      key: socio.key,
      attrs: {
        "label": "CPF",
        "prop": 'socios.' + index + '.cpf',
        "rules": [{
            required: true,
            message: 'O CPF é obrigatório',
            trigger: 'blur'
          },
          {
            validator: _vm.validateCpf,
            trigger: 'blur'
          }
        ]
      }
    }, [_c('div', {
      staticClass: "el-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (socio.cpf),
        expression: "socio.cpf"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('999.999.999-99'),
        expression: "'999.999.999-99'"
      }],
      staticClass: "el-input__inner",
      attrs: {
        "type": "text",
        "placeholder": "999.999.999-99"
      },
      domProps: {
        "value": (socio.cpf)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(socio, "cpf", $event.target.value)
        }
      }
    })])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "offset": 1,
        "span": 7
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Título de Eleitor",
        "prop": 'socios.' + index + '.tituloEleitor'
      }
    }, [_c('el-input', {
      model: {
        value: (socio.tituloEleitor),
        callback: function($$v) {
          _vm.$set(socio, "tituloEleitor", $$v)
        },
        expression: "socio.tituloEleitor"
      }
    })], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addPartner
    }
  }, [_vm._v("Adicionar Sócio")])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('p', [_vm._v("Informe o endereço completo, conforme confsta no IPTU do imóvel.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cep",
      "prop": "cep"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cep),
      expression: "form.cep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99999-999'),
      expression: "'99999-999'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "Cep",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.form.cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cep", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Endereço",
      "prop": "logradouro"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Endereço",
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.form.logradouro),
      callback: function($$v) {
        _vm.$set(_vm.form, "logradouro", $$v)
      },
      expression: "form.logradouro"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Número",
      "prop": "numero"
    }
  }, [_c('el-input', {
    ref: "numero",
    attrs: {
      "placeholder": "Número"
    },
    model: {
      value: (_vm.form.numero),
      callback: function($$v) {
        _vm.$set(_vm.form, "numero", $$v)
      },
      expression: "form.numero"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Complemento",
      "prop": "complemento"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Complemento"
    },
    model: {
      value: (_vm.form.complemento),
      callback: function($$v) {
        _vm.$set(_vm.form, "complemento", $$v)
      },
      expression: "form.complemento"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bairro",
      "prop": "bairro"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Bairro",
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.form.bairro),
      callback: function($$v) {
        _vm.$set(_vm.form, "bairro", $$v)
      },
      expression: "form.bairro"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cidade",
      "prop": "cidade"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cidade",
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.form.cidade),
      callback: function($$v) {
        _vm.$set(_vm.form, "cidade", $$v)
      },
      expression: "form.cidade"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Estado",
      "prop": "estado"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Estado",
      "readonly": _vm.isDisabled
    },
    model: {
      value: (_vm.form.estado),
      callback: function($$v) {
        _vm.$set(_vm.form, "estado", $$v)
      },
      expression: "form.estado"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    class: _vm.classes,
    on: {
      "click": _vm.showForm
    }
  }, [_vm._t("default", [_vm._v("Solicite orçamento para assessoria mensal")])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('p', [_vm._v("Referente a sede da empresa")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("IPTU ou Habite-se do Imóvel onde será a sede da empresa;")]), _vm._v(" "), _c('li', [_vm._v("Cópia do Contrao de Locação se for o caso")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Documentos do(s) empresário, sócio(s), presidente, titular:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Cópia da Identidade (RG);")]), _vm._v(" "), _c('li', [_vm._v("CPF;")]), _vm._v(" "), _c('li', [_vm._v("Comprovante de Residência")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "arquivos"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://cdn.icnex.com/formularios12/?arquivos&adicionar",
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "before-upload": _vm.beforeUpload,
      "on-remove": _vm.onRemove,
      "file-list": _vm.form.arquivos
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.disableField
    }
  }, [_vm._v("Clique aqui para fazer o upload")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Validação para poder enviar a solicitação")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.showForm,
      "width": "75%",
      "top": "5%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showForm = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    key: "form",
    attrs: {
      "element-loading-text": "Enviando os dados, aguarde..."
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_vm._v("Assessoria Contábil")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Preencha o formulário para solicitação de orçamento referente a nossa assessoria")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', [_c('el-col', {
    attrs: {
      "span": _vm.form.socio ? 17 : 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nome",
      "prop": "nome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.$set(_vm.form, "nome", $$v)
      },
      expression: "form.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "socio"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Você é Sócio?")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "Sim",
      "inactive-text": "Não",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    on: {
      "change": _vm.cleanOutro
    },
    model: {
      value: (_vm.form.socio),
      callback: function($$v) {
        _vm.$set(_vm.form, "socio", $$v)
      },
      expression: "form.socio"
    }
  }, [_vm._v("Sócio?")])], 1)], 1), _vm._v(" "), (!_vm.form.socio) ? _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Outros",
      "prop": "outro"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Outro?"
    },
    model: {
      value: (_vm.form.outro),
      callback: function($$v) {
        _vm.$set(_vm.form, "outro", $$v)
      },
      expression: "form.outro"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Telefone Fixo",
      "prop": "telefone"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telefone),
      expression: "form.telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(99) 9999-9999'),
      expression: "'(99) 9999-9999'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "(99) 9999-9999"
    },
    domProps: {
      "value": (_vm.form.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "telefone", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Celular",
      "prop": "celular"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.celular),
      expression: "form.celular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(99) 99999-9999'),
      expression: "'(99) 99999-9999'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "(99) 99999-9999"
    },
    domProps: {
      "value": (_vm.form.celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "celular", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nome da Empresa",
      "prop": "nomeEmpresa"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nomeEmpresa),
      callback: function($$v) {
        _vm.$set(_vm.form, "nomeEmpresa", $$v)
      },
      expression: "form.nomeEmpresa"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "CNPJ da Empresa",
      "prop": "cnpjEmpresa"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cnpjEmpresa),
      expression: "form.cnpjEmpresa"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99.999.999/9999-99'),
      expression: "'99.999.999/9999-99'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "99.999.999/9999-99"
    },
    domProps: {
      "value": (_vm.form.cnpjEmpresa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cnpjEmpresa", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ramo de Atuação",
      "prop": "ramoAtuacao"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 1
      }
    },
    model: {
      value: (_vm.form.ramoAtuacao),
      callback: function($$v) {
        _vm.$set(_vm.form, "ramoAtuacao", $$v)
      },
      expression: "form.ramoAtuacao"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Faturamento médio da empresa",
      "prop": "faturamentoMedio"
    }
  }, [_c('div', {
    staticClass: "el-input el-input-group el-input-group--prepend"
  }, [_c('div', {
    staticClass: "el-input-group__prepend"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.faturamentoMedio),
      expression: "form.faturamentoMedio"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.form.faturamentoMedio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "faturamentoMedio", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "quantidadeFuncionarios"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Quantidade de funcionários")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.form.quantidadeFuncionarios),
      callback: function($$v) {
        _vm.$set(_vm.form, "quantidadeFuncionarios", $$v)
      },
      expression: "form.quantidadeFuncionarios"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "offset": 1,
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "quantidadeNotasEmitidas"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Quantidade de notas emitidas no mês")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.form.quantidadeNotasEmitidas),
      callback: function($$v) {
        _vm.$set(_vm.form, "quantidadeNotasEmitidas", $$v)
      },
      expression: "form.quantidadeNotasEmitidas"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "adquireMercadoriasOutrosEstados"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Empresa adquire mercadorias para revenda e/ou consumo provenientes de outros estados?")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.adquireMercadoriasOutrosEstados),
      callback: function($$v) {
        _vm.$set(_vm.form, "adquireMercadoriasOutrosEstados", $$v)
      },
      expression: "form.adquireMercadoriasOutrosEstados"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Sim"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Não"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Não sei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "atuaExportacaoImportacao"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Empresa atua com exportação ou importação de produtos?")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.atuaExportacaoImportacao),
      callback: function($$v) {
        _vm.$set(_vm.form, "atuaExportacaoImportacao", $$v)
      },
      expression: "form.atuaExportacaoImportacao"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Sim"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Não"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Não sei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "possuiSoftwareGestao"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Empresa possui software de gestão?")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.possuiSoftwareGestao),
      callback: function($$v) {
        _vm.$set(_vm.form, "possuiSoftwareGestao", $$v)
      },
      expression: "form.possuiSoftwareGestao"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Sim"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Não"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "possuiProfissionalAdministrativo"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Possui profissional administrativo dedicado - Contrato CLT?")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.form.possuiProfissionalAdministrativo),
      callback: function($$v) {
        _vm.$set(_vm.form, "possuiProfissionalAdministrativo", $$v)
      },
      expression: "form.possuiProfissionalAdministrativo"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Sim"
    }
  }), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "font-weight": "normal"
    },
    attrs: {
      "label": "Não"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rotatividadeMensalFuncionarios"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Rotatividade mensal de funcionários (média de admissões + rescisões)")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.form.rotatividadeMensalFuncionarios),
      callback: function($$v) {
        _vm.$set(_vm.form, "rotatividadeMensalFuncionarios", $$v)
      },
      expression: "form.rotatividadeMensalFuncionarios"
    }
  })], 1)], 1), _vm._v(" "), _c('vue-recaptcha', {
    ref: "_recaptcha",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.verifyRecaptcha,
      "expired": _vm.recaptchaExpired
    }
  })], 1), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    key: "buttons",
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.isValid,
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_vm._v("Enviar")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.showForm,
      "width": "75%",
      "top": "5%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showForm = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    key: "form",
    attrs: {
      "element-loading-text": "Enviando os dados, aguarde..."
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_vm._v("Abertura de Empresa")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("A partir das informações inseridas, poderá ser feito análise e planejamento para a abertura da sua empresa.")])]), _vm._v(" "), _c('el-col', {
    staticClass: "el-dialog__footer",
    staticStyle: {
      "padding-top": "20px",
      "padding-right": "0"
    },
    attrs: {
      "span": 10
    }
  }, [(_vm.step !== 0) ? _c('el-button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(_vm.step - 1)
      }
    }
  }, [_vm._v("Passo anterior")]) : _vm._e(), _vm._v(" "), (_vm.totalSteps !== (_vm.step + 1)) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(_vm.step + 1)
      }
    }
  }, [_vm._v("Próximo passo")]) : _vm._e(), _vm._v(" "), (_vm.isValid) ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isValid,
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_vm._v("Enviar")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-steps', {
    attrs: {
      "space": 75,
      "active": _vm.step,
      "direction": "vertical"
    }
  }, [_c('a', {
    style: (_vm.getStepCursor(0)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(0)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Dados do Solicitante",
      "description": "Informações Pessoais",
      "status": _vm.steps[0].class
    }
  })], 1), _vm._v(" "), _c('a', {
    style: (_vm.getStepCursor(1)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(1)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Dados da Pessoa Jurídica",
      "description": "Nomes a escolher",
      "status": _vm.steps[1].class
    }
  })], 1), _vm._v(" "), _c('a', {
    style: (_vm.getStepCursor(2)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(2)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Endereço da Empresa",
      "description": "A ser constituida",
      "status": _vm.steps[2].class
    }
  })], 1), _vm._v(" "), _c('a', {
    style: (_vm.getStepCursor(3)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(3)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Atividades a ser exercida",
      "description": "Pela empresa a ser constituida",
      "status": _vm.steps[3].class
    }
  })], 1), _vm._v(" "), _c('a', {
    style: (_vm.getStepCursor(4)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(4)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Dados do Contrato Social",
      "description": "Informações sobre sócios",
      "status": _vm.steps[4].class
    }
  })], 1), _vm._v(" "), _c('a', {
    style: (_vm.getStepCursor(5)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(5)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Administração e Assinatura",
      "description": "Da empresa",
      "status": _vm.steps[5].class
    }
  })], 1), _vm._v(" "), _c('a', {
    style: (_vm.getStepCursor(6)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(6)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Outras Informações",
      "description": "Atendimento/tipo da empresa",
      "status": _vm.steps[6].class
    }
  })], 1), _vm._v(" "), _c('a', {
    style: (_vm.getStepCursor(7)),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(7)
      }
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Documentos Necessários",
      "description": "Para abertura da empresa",
      "status": _vm.steps[7].class
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('solicitante', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 0),
      expression: "step === 0"
    }],
    ref: "step-0",
    attrs: {
      "form": _vm.form.solicitante
    }
  }), _vm._v(" "), _c('pessoa-juridica', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 1),
      expression: "step === 1"
    }],
    ref: "step-1",
    attrs: {
      "form": _vm.form.pessoaJuridica
    }
  }), _vm._v(" "), _c('endereco-empresa', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 2),
      expression: "step === 2"
    }],
    ref: "step-2",
    attrs: {
      "form": _vm.form.enderecoEmpresa
    }
  }), _vm._v(" "), _c('atividades-ser-exercida', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 3),
      expression: "step === 3"
    }],
    ref: "step-3",
    attrs: {
      "form": _vm.form.atividadesSerExercida
    }
  }), _vm._v(" "), _c('contrato-social', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 4),
      expression: "step === 4"
    }],
    ref: "step-4",
    attrs: {
      "form": _vm.form.contratoSocial
    }
  }), _vm._v(" "), _c('administracao-assinatura', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 5),
      expression: "step === 5"
    }],
    ref: "step-5",
    attrs: {
      "form": _vm.form.administracaoAssinatura
    }
  }), _vm._v(" "), _c('diversos', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 6),
      expression: "step === 6"
    }],
    ref: "step-6",
    attrs: {
      "form": _vm.form.diversos
    }
  }), _vm._v(" "), _c('documentos-necessarios', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step === 7),
      expression: "step === 7"
    }],
    ref: "step-7",
    attrs: {
      "form": _vm.form.documentosNecessarios
    }
  }), _vm._v(" "), _c('vue-recaptcha', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalSteps === (_vm.step + 1)),
      expression: "totalSteps === (step+1)"
    }],
    ref: "_recaptcha",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.verifyRecaptcha,
      "expired": _vm.recaptchaExpired
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    key: "buttons",
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.step !== 0) ? _c('el-button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(_vm.step - 1)
      }
    }
  }, [_vm._v("Passo anterior")]) : _vm._e(), _vm._v(" "), (_vm.totalSteps !== (_vm.step + 1)) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToStep(_vm.step + 1)
      }
    }
  }, [_vm._v("Próximo passo")]) : _vm._e(), _vm._v(" "), (_vm.isValid) ? _c('el-button', {
    attrs: {
      "disabled": !_vm.isValid,
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_vm._v("Enviar")]) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validaCpf; });
var calcChecker1 = function calcChecker1(firstNineDigits) {
  var sum = null;

  for (var j = 0; j < 9; ++j) {
    sum += firstNineDigits.toString().charAt(j) * (10 - j);
  }

  var lastSumChecker1 = sum % 11;

  return lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;
};

var calcChecker2 = function calcChecker2(cpfWithChecker1) {
  var sum = null;

  for (var k = 0; k < 10; ++k) {
    sum += cpfWithChecker1.toString().charAt(k) * (11 - k);
  }

  var lastSumChecker2 = sum % 11;

  return lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;
};

var validaCpf = function validaCpf(rule, value, callback) {
  var cleanCPF = value.replace(/\.|-|\s/g, '');
  var firstNineDigits = cleanCPF.substring(0, 9);
  var checker = cleanCPF.substring(9, 11);

  if (cleanCPF.length !== 11) {
    callback(new Error('O CPF não possui 11 digitos'));
  }

  for (var i = 0; i < 10; i++) {
    if ('' + firstNineDigits + checker === Array(12).join(i)) {
      return false;
    }
  }

  var checker1 = calcChecker1(firstNineDigits);
  var checker2 = calcChecker2(firstNineDigits + '' + checker1);

  if (!(checker.toString() === checker1.toString() + checker2.toString())) {
    callback(new Error('O CPF é inválido'));
  } else {
    callback();
  }
};

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[109]);


// WEBPACK FOOTER //
// static/js/app.js